import type { ReactNode, SVGProps } from "react";

export function AccountIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="12"
			viewBox="0 0 14 12"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.625 3.07683C0.625 2.49539 0.845121 1.93777 1.23694 1.52663C1.62875 1.1155 2.16017 0.884521 2.71429 0.884521H11.0714C11.6255 0.884521 12.157 1.1155 12.5488 1.52663C12.9406 1.93777 13.1607 2.49539 13.1607 3.07683V8.92298C13.1607 9.50442 12.9406 10.062 12.5488 10.4732C12.157 10.8843 11.6255 11.1153 11.0714 11.1153H2.71429C2.16017 11.1153 1.62875 10.8843 1.23694 10.4732C0.845121 10.062 0.625 9.50442 0.625 8.92298V3.07683Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 4.53857H13.1607"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.41113 8.19238H3.42069"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.19678 8.19238H7.58963"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
